<template>
  <div class="Site IndexBox" style="padding-top: 48px">
    <div class="PageBox" style="padding: 0">
      <van-nav-bar fixed :border="false" :title="$t('promote[13]')" left-arrow
      @click-left="$router.push('/')" />
      <div class="ScrollBox">
        <div class="PromoteInfo" :style="{ backgroundImage: 'url(' + InitData.setting.user_invite_img + ')' }">
          <div v-if="UserInfo.vip_level > 2" style="position: relative;top:250px;background-color: #fff;border-radius: 5px;margin: 0 10px;width: calc(100% - 20px);text-align:justify;padding:10px;color:#000;">
             <div v-if="UserInfo.danger==2">
                <div style="display: flex;padding:10px;width: 100%;border-bottom: 1px solid #d3d3d3;">
                  <div style="width: 25px;">
                    <img :src="`./static/images/invitation/link.png`" width="20px" height="20px">
                  </div>
                  <div style="padding-left:10px;width:calc(100% - 100px);text-align: left;">
                    <a href="javascript:;" @click="$Util.CopyText('IosCode', 'AppCode')"
                      style="margin-top: 0px;color:#72aefe">{{ $t('promote[3]') }}</a>
                    <p class="m0" style="">{{ $t('promote[2]') }}：<span id="IosCode">{{ UserInfo.idcode }}</span></p>
                    <input id="AppCode" type="text" readonly :value="UserInfo.idcode" style="position: absolute;opacity: 0">
                  </div>
                  <div style="text-align:right;width:50px;margin-right: 10px;">
                    <van-button plain type="info" size="mini"
                      @click="$Util.CopyText('IosCode', 'AppCode')">copy</van-button>
                  </div>
                </div>

                <div style="display: flex; padding:10px;width: 100%;border-bottom: 1px solid #d3d3d3;">
                  <div style="width: 25px;">
                    <img :src="`./static/images/invitation/link.png`" width="20px" height="20px">
                  </div>
                  <div style="padding-left:10px;width: calc(100% - 100px);text-align: left;">
                    <a href="javascript:;" @click="$Util.CopyText('IosLink', 'AppLink')"
                      style="margin-top: 0px;color:#72aefe">{{ $t('promote[3]') }}</a>
                    <p class="m0" style="text-align: left;"><span id="IosLink">{{ promoteUrl }}</span></p>
                    <input id="AppLink" type="text" readonly :value="promoteUrl" style="position: absolute;opacity: 0">
                  </div>
                  <div style="text-align:right;width:50px;margin-right: 10px;">
                    <van-button plain type="info" size="mini"
                      @click="$Util.CopyText('IosLink', 'AppLink')">copy</van-button>
                  </div>
                </div>
                <div style="text-align: center;padding-top: 10px;">
                  <div id="QRCode"></div>
                </div>
            </div>   
            
          </div>
          
          <div v-else
              style="position: relative;top:250px;background-color: #fff;border-radius: 5px;margin: 0 10px;width: calc(100% - 20px);text-align:justify;padding:10px;color:#000;">
              {{ $t('promote[12]') }}
            </div> 
          <div style="height: 260px;"></div>
          <div style="background-color: #fff;border-radius: 5px;margin: 0 10px;margin-bottom: 10px;">
            <div class="content-member">
              <h2 style="color: #000;text-align: center;font-size: 1.2rem;padding-top: 35px;">{{ $t('promote[15]') }}</h2>
              <div
                style="color: #000;text-align: left;text-indent: 10px; font-size: 0.9rem;padding: 0 20px;;padding-bottom: 20px;margin-top: 25px;word-wrap: break-word;word-break: break-all;"
                v-html="$t('promote[14]')"></div>
           
            </div>
          </div>
          <!-- <div style="padding-top:40%;" class="center-block" v-if="UserInfo.vip_level > 1">
              <h4>{{ $t('promote[0]') }}{{ UserInfo.username }}</h4>
              <h4>{{ $t('promote[1]', { title: docTitle }) }}</h4>
              <div id="QRCode"></div>
              <h4 class="m0">{{ $t('promote[2]') }}：<span id="IosCode">{{ UserInfo.idcode }}</span></h4>
              <input id="AppCode" type="text" readonly :value="UserInfo.idcode" style="position: absolute;opacity: 0">
              <a href="javascript:;" @click="$Util.CopyText('IosCode', 'AppCode')"><van-icon
                  name="description" />{{ $t('promote[3]') }}</a>
              <div>
                <span id="IosLink">{{ promoteUrl }}</span>
                <input id="AppLink" type="text" readonly :value="promoteUrl" style="position: absolute;opacity: 0">
              </div>
              <a href="javascript:;" @click="$Util.CopyText('IosLink', 'AppLink')"><van-icon
                  name="description" />{{ $t('promote[4]') }}</a>
            </div>
            <div v-else
              style="text-align: center;width: 350px;height: 40px;margin: auto;position: absolute;top: 0;left: 0;right: 0;bottom: 0;">
              {{ $t('promote[12]') }}
            </div> -->
          <!-- <div style="margin-top: 20px;display: flex;justify-content: space-between;">
          <van-button block style="font-size: 16px;background:#000;color: #fff;margin-right: 8px" @click="saveQRCode">{{$t('promote[5]')}}</van-button>
          <van-button block type="info" style="font-size: 16px;margin-left: 8px" @click="showReward=true">{{$t('promote[6]')}}</van-button>
        </div> -->
        </div>
      </div>

      <Footer />
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2"
export default {
  name: 'Promote',
  components: {
  },
  props: ['isReward'],
  data() {
    return {
      promoteUrl: '',
      saveN: 0,
      showReward: false,
      docTitle: document.title,
      list:[],
      vip_num:0,
    }
  },
  computed: {

  },
  watch: {

  },
  created() {
    this.$Model.GetUserInfo()
    if (this.isReward) {
      this.showReward = true
    }
    this.$parent.navBarTitle = this.$t("promote[13]")
    this.InitData.setting.reg_url = window.location.origin
    this.promoteUrl = this.InitData.setting.reg_url + `/#/register/${this.UserInfo.idcode}`
  },
  mounted() {
    new QRCode(document.getElementById("QRCode"), {
      text: this.promoteUrl,
      width: 110,
      height: 110,
      correctLevel: QRCode.CorrectLevel.H
    });
	  this.getData()
  },
  activated() {

  },
  destroyed() {

  },
  methods: {
    saveQRCode() {
      if (window.plus) {
        this.saveN += 1
        var img = $('#QRCode').find('img').attr('src').replace('data:image/png;base64,', '')
        var bm = new plus.nativeObj.Bitmap()
        bm.loadBase64Data(img, () => {
          bm.save('_doc/promote' + this.saveN + '.jpg', { 'overwrite': true, 'format': 'jpg' }, (e) => {
            plus.gallery.save(e.target, (e) => {
              this.$Dialog.Toast(this.$t('promote[7]'))
            }, (err) => {
              this.$Dialog.Toast(this.$t('promote[8]'))
            });
          }, (error) => {
            this.$Dialog.Toast(this.$t('promote[8]'))
          });
          setTimeout(function () {
            bm.recycle();
          }, 1000);
        }, (err) => {
          this.$Dialog.Toast(this.$t('promote[8]'))
        });
      } else {
        var img = $('#QRCode').find('img').attr('src')
        this.downCanvas(img)
      }
    },
    downCanvas(url) {
      var a = document.createElement('a')
      var event = new MouseEvent('click')
      a.download = 'promote'
      a.href = url
      a.dispatchEvent(event)
      if (!url) {
        this.$Dialog.Toast(this.$t('promote[9]'))
      }
    },
    clickBtn(id) {
		  this.$Model.doDirect(id,data=>{
			  this.$Dialog.Toast(data.code_dec);
			  this.getData();
		  })
	  },
	  getStr(num) {
		  return  this.vip_num + "/" + num;
	  },
	  moneyFormat(num) {
	  	return new Intl.NumberFormat().format(Number(num).toFixed(2));
	  },
	  getData() {
		  this.$Model.getDirect({},data=>{
		  	this.list = data.activity;
		  	this.vip_num = data.direct;
		  })
	  }
  }
}
</script>
<style lang="scss" scoped>
.PromoteInfo {
  background-color: #1e513c; /* 与插画底部深绿色一致，避免留白 */
  background-repeat: no-repeat;
  background-position: top center;
  /* 宽度铺满，高度按比例自适应，避免压缩/拉伸变形 */
  background-size: 100% auto;
  color: #786767;
  text-align: center;
  min-height: 100%;
  position: absolute;
  /* 从内容区顶部开始，保证插画顶部（深绿条、Сафари 等）在导航栏下方完整展示，不被遮挡 */
  top: 0;
  left: 0;
  right: 0;
}

.center-block {
  margin: 0 auto;
}

.PromoteInfo h4 {
  margin-bottom: 20px;
}

.PromoteInfo a {
  color: #1a6ba1;
  margin-top: 15px;
  display: inline-block;
}

.PromoteInfo a .van-icon {
  font-size: 20px;
  vertical-align: middle;
  margin-right: 5px;
}

.PromoteInfo #IosLink {
  word-break: break-all;
  margin-top: 15px;
  display: block;
  text-align: left;
}

#QRCode {
  margin-bottom: 16px;
  display: inline-block;
  padding: 5px;
  background-color: #fff;
  font-size: 0;
}

/deep/.van-step--horizontal .van-step__circle-container {
  position: absolute;
  top: 30px;
  z-index: 1;
  padding: 0 8px;
  background-color: #72aefe;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  left: -2px;
}

/deep/.van-step--horizontal .van-step__icon {
  font-size: 16px;
}

/deep/.van-nav-bar__content {
  background: linear-gradient(to right, $theme-shallow-color, $theme-color);
  color: #fff;
}

/deep/.van-nav-bar__title {
  color: #fff;
}

/deep/.van-nav-bar .van-icon {
  color: #fff !important;
}

/deep/.van-button--mini {
  height: 1.625rem;
  color: #72aefe;
  background-color: #fff;
  border: .0625rem solid #72aefe;
}
</style>